import src from "IMAGE";
export default { src, width: 167, height: 26, blurWidth: 0, blurHeight: 0};
